import { ValuePointItem } from './styled';

interface IValuePointProps {
  text: string;
  subText: string;
}

const ValuePoint = ({ subText, text }: IValuePointProps) => (
  <ValuePointItem>
    <span className="text">{text}</span>
    <span className="subtext">{subText}</span>
  </ValuePointItem>
);

export default ValuePoint;
